/** Login destinations must remain on this origin after browser URL normalization. */
export function safeLoginNext(value: string | null, origin: string): string {
  if (!value?.startsWith("/") || value.startsWith("//") || Array.from(value).some((character) => character === "\\" || character.charCodeAt(0) <= 32 || character.charCodeAt(0) === 127)) return "/dashboard";
  try {
    const destination = new URL(value, origin);
    if (destination.origin !== new URL(origin).origin) return "/dashboard";
    // Keep the absolute URL: returning a normalized path starting with // would
    // make location.href reinterpret that same-origin path as an external host.
    return destination.href;
  } catch {
    return "/dashboard";
  }
}
